<template>
  <div v-if="loaded" class="project-layout">
    <app-header>
      <template #title>
        <stage-selector :project="project" :stage="stage"></stage-selector>
      </template>
      <template #actions>
        <sprint-selector v-if="$route.name == 'projects.stage3.scrum' || $route.name == 'projects.stage3.planner'" :project="project" :stage="stage" :sprint="sprint" :sprints="sprints"></sprint-selector>

        <ul class="active-filters">
            <li v-if="filters.status">Status: {{filters.status}}<a href="#" v-on:click.prevent="setStateProperty({ property: 'filters.status', value: null })"><i class="far fa-times"></i></a></li>
            <li v-for="user in filters.users" v-bind:key="user.id">User: {{user.name}}<a href="#" v-on:click.prevent="unsetUserFromFilterById(user.id)"><i class="far fa-times"></i></a></li>
        </ul>
      </template>
    </app-header>

    <div class="layout-sidesheet row">
      <div class="col main-content d-flex flex-column">
        <ul id="horizontal-nav" class="nav nav-horizontal sticky-top" style="position: sticky">
          <router-link @click.native="reload" tag="li" class="nav-item" :to="{name: 'projects.stage3.overview'}">
              <a class="nav-link">Overview</a>
          </router-link>
          <router-link v-if="stage.user_story_doc_id" tag="li" class="nav-item" :to="{name: 'projects.stage3.deliverables', params: {user_story_doc_id: stage.user_story_doc_id, sprint_id: 'active'}}">
              <a class="nav-link">Deliverables</a>
          </router-link>
          <router-link v-if="stage.scrum_user_story_doc_id" tag="li" class="nav-item" :to="{name: 'projects.stage3.scrum', params: {user_story_doc_id: stage.scrum_user_story_doc_id, sprint_id: 'active'}}">
              <a class="nav-link">Scrum Board</a>
          </router-link>
          <router-link v-if="stage.scrum_user_story_doc_id" tag="li" class="nav-item" :to="{name: 'projects.stage3.planner', params: {user_story_doc_id: stage.scrum_user_story_doc_id, sprint_id: 'active'}}">
              <a class="nav-link">Sprint Planner</a>
          </router-link>
          <router-link v-if="stage.scrum_user_story_doc_id" tag="li" class="nav-item" :to="{name: 'projects.stage3.issueboard', params: {user_story_doc_id: stage.scrum_user_story_doc_id, sprint_id: 'active'}}">
              <a class="nav-link">Issues</a>
          </router-link>
        </ul>
        <!-- /#horizontal-nav -->

        <edit-drawer v-if="this.$route.name == 'projects.stage3.overview'" ref="editDrawer"></edit-drawer>

        <router-view></router-view>
      </div>

      <div class="col-auto project-right-nav">
        <ul>
          <li v-if="this.$route.name == 'projects.stage3.overview'">
              <button type="button" class="btn" @click="openDrawer('editDrawer')">
                  <i class="far fa-edit"></i>
              </button>
          </li>
          <li>
              <button type="button" class="btn" @click="openBoardDrawer('filters')">
                  <i class="far fa-filter"></i>
              </button>
          </li>
          <li>
              <button type="button" class="btn" @click="openBoardDrawer('renderOptions')">
                  <i class="far fa-eye"></i>
              </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

    import { findIndex, find } from 'lodash'
    import EditDrawer from './project/stage/EditDrawer'
    import stageSelector from './_stage-selector'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import sprintSelector from './project/scrumboard/_sprint-selector'

    export default {

        data: function () {
            return {
                loaded: false,
                members: []
            }
        },
        components: {
            EditDrawer,
            stageSelector,
            sprintSelector
        },

        computed: {
            ...mapState('yodizproject', {
                project: 'single'
            }),

            ...mapState('yodizproject/sprints', {
                sprints: 'list'
            }),

            ...mapState('yodizproject/sprints', {
                sprint: 'single'
            }),

            ...mapState('yodizproject/stages', {
                stage: 'single',
                stages: 'list'
            }),

            ...mapState('yodizproject/stories', {
                filters: 'filters'
            }),

        },
        beforeRouteUpdate (to, from, next) {

            //Refresh stage data if user has navigated back to the overview
            if (to.name == 'projects.stage3.overview') {
                this.getStage(this.$route.params.stage_id)
            }

            next()
        },
        mounted: function() {

            this.getYodizProject(this.$route.params.project_id).then(() => {
                this.getStage(this.$route.params.stage_id).then(() => {
                    this.loaded = true
                })
            });

            this.getUsers();
        },

        methods: {
            ...mapActions('yodizproject', {
                getYodizProject: 'getSingle'
            }),

            ...mapActions('yodizproject/stages', {
               getStage: 'getSingle'
            }),

            ...mapActions('yodizproject/stories', {
                setStateProperty: 'setStateProperty',
                unsetUserFromFilterById: 'unsetUserFromFilterById'
            }),


            ...mapActions('users', ['getUsers']),
            ...mapActions('tags', ['getTagsList']),

            reload() {
                this.getStage(this.$route.params.stage_id)
            },

            openDrawer (ref) {
                if (this.$refs[ref]) {
                    this.$refs[ref].open()
                }
            },

            // Board drawers live in the child board components
            openBoardDrawer (drawer) {
                this.$bus.$emit('project-board:open-drawer', drawer)
            }

        },

    }
</script>
